import { memo, useState, useEffect, useReducer, createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import i18n from 'i18next';
// @mui
import { styled, useTheme } from '@mui/material/styles';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  Button,
  Drawer,
  CardContent,
  Card,
  CardHeader,
  Tabs,
  Tab,
  Stack,
  Typography,
  Pagination, Backdrop, MenuList, MenuItem,
} from '@mui/material';

// components
import {
  SvgArrowNarrowRightFill,
  SvgChevronLeftFill,
  SvgDotFill,
} from '../../SvgIcons';
import Scrollbar from '../../scrollbar';
import { LoadingScreen } from '../../loading-screen';
import { NoData } from '../../error';

// store
import { I18_NEXT_LNG, READ_FLAG } from '../../../store/types';
import { HEADER } from '../../../store/constant';

import { setStorage } from '../../../utils/storage';
/* ======================================================================================= */


const NotificationContent = ({ readFlag, list = [], total = 0, handleChangePage, handleChangeRowsPerPage, page, rowsPerPage, pages, handleViewDetails }) => {
  const theme = useTheme();
  return list?.length > 0 ? (
    <Box role="presentation">
      <Scrollbar sx={{ height: '78vh' }}>
        <List disablePadding sx={{ pb: 0.25 }}>
          {_.map(list, (item, index) => (
            <ListItem key={index} disablePadding sx={{ ...theme.typography.hoverPrimaryLeftline2px }} onClick={() => handleViewDetails(item)}>
              <ListItemButton
                sx={{
                  py: 1.5,
                  pl: 1.5,
                  pr: 3,
                  position: 'relative',
                  overflow: 'hidden',
                  borderBottom: '1px solid #CCC',
                  '& .MuiListItemText-root': {
                    m: 0,
                    position: 'relative',
                    overflow: 'hidden'
                  },
                  '& .Sim-icon-link': {
                    width: 0,
                    lineHeight: 0,
                    pl: 3,
                    transform: 'translateX(70px)',
                    transition: 'all 0.3s 0s ease-out',
                  },
                  '&:hover': {
                    backgroundColor: theme => theme.palette.action.hover,
                    '& .Sim-icon-link': {
                      width: 46,
                      transform: 'translateX(0px)'
                    }
                  }
                }}
              >
                <ListItemText
                  primary={
                    <Typography
                      mb={1}
                      display={'block'}
                      component="span"
                      variant="subtitle1"
                      fontWeight={item?.avatar ? 700 : 400}
                      color="text.primary"
                      sx={{ ...theme.typography.lineClamp1 }}
                    >
                      {
                        [READ_FLAG.Unread].includes(Number(item?.readFlag)) && (
                          <Box component={'i'} width={6} display={'inline-block'} mr={1} sx={{ verticalAlign: 'text-bottom' }}>
                            <SvgDotFill />
                          </Box>
                        )
                      }
                      {item?.titile}
                    </Typography>
                  }
                  secondary={
                    <Typography
                      component="span"
                      variant={'body2'}
                      color={'text.secondary'}
                      display={'flex'}
                      alignItems={'center'}
                    >
                      {item?.sendTime}
                      {item?.sysBmApplication?.applicationName && (<Divider sx={{ width: 3, height: 3, alignSelf: 'center', mx: 1 }} color={'error.main'} orientation="vertical" variant="middle" flexItem />)}
                      {item?.sysBmApplication?.applicationName}
                    </Typography>
                  }
                />
                <Box className={'Sim-icon-link'}>
                  <SvgArrowNarrowRightFill />
                </Box>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Scrollbar>
      <Stack width={'100%'} direction={'row'} spacing={2} py={3} alignItems={'center'} justifyContent={'center'}>
        {/* <Box>共&nbsp;{ total }&nbsp;筆</Box> */}
        {/* <FormControl sx={{ m: 1, minWidth: '5rem' }} size="small" className="mx-0 my-0">
          <Select value={rowsPerPage} onChange={handleChangeRowsPerPage} displayEmpty inputProps={{ 'aria-label': 'Without label' }}>
            {_.map([10, 20, 30, 40], (option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}
        <Pagination
          variant={'text'}
          shape="rounded"
          size={'medium'}
          count={pages}
          page={page}
          defaultPage={page}
          onChange={handleChangePage}
        />
        {/* <Box display={'flex'} alignItems={'center'}>
          <Typography variant={'h6'} fontWeight={400}>跳至</Typography>
          <TextField
            id="outlined-size-small"
            defaultValue=""
            size="small"
            sx={{
              mx: 1,
              '& .MuiInputBase-root': {
                maxHeight: 32,
                maxWidth: 64
              }
            }}
          />
          <Typography variant={'h6'} fontWeight={400}>頁</Typography>
        </Box> */}
      </Stack>
    </Box>
  ) : (<NoData />)
};
NotificationContent.propTypes = {
  readFlag: PropTypes.number,
  list: PropTypes.array,
  total: PropTypes.number,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  pages: PropTypes.number,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func,
  handleViewDetails: PropTypes.func
};

/* ======================================================================================= */

const LanguageList = ({ ct }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { account: { lngOptions } } = useSelector(
    (state) => state
  );

  const { state, commit } = useContext(ct);
  const { open } = state || {};

  const handleCloseList = (visible) => (event) => {
    commit({
      type: 'OPEN_LIST_DRAWER',
      data: {
        ...state,
        open: visible,
      }
    });
  };

  // 選擇語言
  const switchLanguage = (option) => {
    window.location.reload();
    setStorage(I18_NEXT_LNG, option.value);
    i18n?.changeLanguage(option.value);
  };

  return (
    <Drawer
      variant={'temporary'}
      anchor={'left'}
      open={Boolean(open)}
      disableScrollLock={Boolean(true)}
      ModalProps={{
        keepMounted: true,
        sx: {
          top: `${HEADER.MOBILE_HEIGHT}px`,
        }
      }}
      PaperProps={{
        sx: {
          mt: `${HEADER.MOBILE_HEIGHT}px`,
          width: '100%',
          bgcolor: 'background.default',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundOrigin: 'border-box',
          backgroundImage: `url('https://www.honhai.com/img/index/menu-bg-m.png')`
        },
      }}
    >
      <Card sx={{ width: 516, borderRadius: 0, backgroundColor: 'transparent' }}>
        <CardHeader
          disableTypography
          title={
            <Stack direction={'row'} color={theme => theme.palette.common.white}>
              <Box onClick={handleCloseList(false)} px={2} ml={-2} sx={{ cursor: 'pointer' }}>
                <SvgChevronLeftFill color={'#A5D6FF'} />
              </Box>
              <Typography color={'secondary.main'}>
                當前位置: 繁體中文
              </Typography>
            </Stack>
          }
          sx={{
            py: 2.5,
            pl: 3,
            pr: 2,
            borderBottom: '1px solid #CCC',
          }}
        />
        <CardContent sx={{ p: 0 }}>
          <MenuList>
            {
              _.map(lngOptions, (option, index) => {
                return (
                  <MenuItem
                    key={index}
                    selected={option.value === i18n.language}
                    onClick={() => switchLanguage(option)}
                    sx={{
                      color: 'common.white',
                      '&.Mui-selected': {
                        backgroundColor: `${theme.palette.action.hover} !important`,
                      }
                    }}
                  >
                    {option.label}
                  </MenuItem>
                )
              })
            }
          </MenuList>
        </CardContent>
      </Card>
    </Drawer>
  );
};

export default memo(LanguageList);
